<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="SetInvoiceVatPeriod"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      name="createOptions"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="vat_period"
        row
        label-cols-md="0"
        content-cols-md="12"
        required
        :label="'VAT Period'|pgettext('SetInvoiceVatPeriod')"
      >
        <ItpFormSelect
          name="vat_period"
          v-model="item.vat_period"
          :options="vatPeriods"
          valueField="id"
          textField="name"
          required
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <ItpFormGroup
        name="lock_invoices"
        :description="'Lock invoices in order to prevent further modifications'|pgettext('SetInvoiceVatPeriod')"
        row
        label-cols-md="0"
        content-cols-md="12"
      >
        <ItpFormCheckbox
          name="lock_invoices"
          v-model="item.lock_invoices"
          :label="'Lock invoices'|pgettext('SetInvoiceVatPeriod')"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="forms.createOptions && forms.createOptions.id"
      :text="'Submit'|pgettext('SetInvoiceVatPeriod')"
      type="submit"
      variant="primary"
      :spinning="actions.submit.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|pgettext('SetInvoiceVatPeriod')"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class SetInvoiceVatPeriod extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_item = new ComponentValueCache(this, "item", "SetInvoiceVatPeriod.item");
  }

  @Prop({
    required: true,
    default: null,
  })
  invoices!: list;

  @Watch('invoices')
  onInvoices(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoices")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  vatPeriods!: any;

  async $$load_vatPeriods() {
    return this.$app.repo.get('list_vat_periods')
  }

  item!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['vatPeriods', 'item', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        vatPeriods: null,
        item: {
          vat_period: null,
          lock_invoices: false,
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("SetInvoiceVatPeriod", "Set VAT period"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3280_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3280, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_3286_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_3286, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        value: true,
      }
      ,
    }
  }

  async act_1040167445267876_request_3284_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_3284, alias=submit
    return {
      operation: "bulk_set_invoice_vat_period",
      data: {
        ...this.item,
        vat_period: { id: this.item.vat_period },
        invoices: this.invoices.map(p => ({ id: p.id }))
      },
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3280: actions.CloseModalAction;
    evh_7315092382398562_close_3279: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_3282: actions.CloseComponentAction;
    evh_2248226175642056_close_3281: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_3286: actions.CloseModalAction;
    evh_1040167445267876_success_3285: actions.EventHandlerImpl;
    act_1040167445267876_request_3284: actions.RequestAction;
    evh_1040167445267876_submit_3283: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_3288: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_3287: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3280 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3280_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3279 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3280,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3279],
      }
    );
    const act_2248226175642056_closeComponent_3282 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3281 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_3282,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3281],
      }
    );
    const act_1040167445267876_closeModal_3286 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_3286_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3285 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_3286,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_3284 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_3284_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_3285],
      }
    );
    const evh_1040167445267876_submit_3283 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_3284,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3283],
      }
    );
    const act_1419464017721962_closeComponent_3288 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3287 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_3288,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3287],
      }
    );
    return {
      act_7315092382398562_closeModal_3280,
      evh_7315092382398562_close_3279,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_3282,
      evh_2248226175642056_close_3281,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_3286,
      evh_1040167445267876_success_3285,
      act_1040167445267876_request_3284,
      evh_1040167445267876_submit_3283,
      evh_1040167445267876_submit,
      act_1419464017721962_closeComponent_3288,
      evh_1419464017721962_clickPreventStop_3287,
      evh_1419464017721962_clickPreventStop,
      submit: act_1040167445267876_request_3284,
    }
  }
}

Vue.component("SetInvoiceVatPeriod", SetInvoiceVatPeriod);

</script>